<template>
  <a-modal
    title="编辑护士端-用户表"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['id']" /></a-form-item>
        <a-form-item
          label="用户名"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入用户名" v-decorator="['username', {rules: [{required: true, message: '请输入用户名！'}]}]" />
        </a-form-item>
        <a-form-item
          label="密码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入密码" v-decorator="['password', {rules: [{required: true, message: '请输入密码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="头像地址"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入头像地址" v-decorator="['avatar', {rules: [{required: true, message: '请输入头像地址！'}]}]" />
        </a-form-item>
        <a-form-item
          label="明文密码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入明文密码" v-decorator="['pw', {rules: [{required: true, message: '请输入明文密码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="真实姓名"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入真实姓名" v-decorator="['realName', {rules: [{required: true, message: '请输入真实姓名！'}]}]" />
        </a-form-item>
        <a-form-item
          label="手机号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入手机号" v-decorator="['phone', {rules: [{required: true, message: '请输入手机号！'}]}]" />
        </a-form-item>
        <a-form-item
          label="证件类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入证件类型" v-decorator="['idcardTypeCode', {rules: [{required: true, message: '请输入证件类型！'}]}]" />
        </a-form-item>
        <a-form-item
          label="证件号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入证件号" v-decorator="['idcardNo', {rules: [{required: true, message: '请输入证件号！'}]}]" />
        </a-form-item>
        <a-form-item
          label="性别"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入性别" v-decorator="['gender', {rules: [{required: true, message: '请输入性别！'}]}]" />
        </a-form-item>
        <a-form-item
          label="出生日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择出生日期" v-decorator="['birthdate',{rules: [{ required: true, message: '请选择出生日期！' }]}]" @change="onChangebirthdate"/>
        </a-form-item>
        <a-form-item
          label="证书编号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入证书编号" v-decorator="['certNo', {rules: [{required: true, message: '请输入证书编号！'}]}]" />
        </a-form-item>
        <a-form-item
          label="证书图片，多个逗号分隔"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入证书图片，多个逗号分隔" v-decorator="['certPics', {rules: [{required: true, message: '请输入证书图片，多个逗号分隔！'}]}]" />
        </a-form-item>
        <a-form-item
          label="职称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入职称" v-decorator="['nurseTitleCode', {rules: [{required: true, message: '请输入职称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="从业开始时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择从业开始时间" v-decorator="['employmentTime',{rules: [{ required: true, message: '请选择从业开始时间！' }]}]" @change="onChangeemploymentTime"/>
        </a-form-item>
        <a-form-item
          label="机构id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入机构id" v-decorator="['organId', {rules: [{required: true, message: '请输入机构id！'}]}]" />
        </a-form-item>
        <a-form-item
          label="科室id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入科室id" v-decorator="['deptId', {rules: [{required: true, message: '请输入科室id！'}]}]" />
        </a-form-item>
        <a-form-item
          label="等级，1初级2中级3高级"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入等级，1初级2中级3高级" v-decorator="['level', {rules: [{required: true, message: '请输入等级，1初级2中级3高级！'}]}]" />
        </a-form-item>
        <a-form-item
          label="账号状态(1=正常, 2=禁用)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入账号状态(1=正常, 2=禁用)" v-decorator="['status', {rules: [{required: true, message: '请输入账号状态(1=正常, 2=禁用)！'}]}]" />
        </a-form-item>
        <a-form-item
          label="登陆次数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入登陆次数" v-decorator="['loginCount', {rules: [{required: true, message: '请输入登陆次数！'}]}]" />
        </a-form-item>
        <a-form-item
          label="是否备案，0否1是"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入是否备案，0否1是" v-decorator="['isRecord', {rules: [{required: true, message: '请输入是否备案，0否1是！'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import moment from 'moment'
  import { baNurseUserEdit } from '@/api/modular/interhospital/banurseuser/baNurseUserManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        birthdateDateString: '',
        employmentTimeDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      moment,
      // 初始化方法
      edit (record) {
        this.visible = true
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              id: record.id,
              username: record.username,
              password: record.password,
              avatar: record.avatar,
              pw: record.pw,
              realName: record.realName,
              phone: record.phone,
              idcardTypeCode: record.idcardTypeCode,
              idcardNo: record.idcardNo,
              gender: record.gender,
              certNo: record.certNo,
              certPics: record.certPics,
              nurseTitleCode: record.nurseTitleCode,
              organId: record.organId,
              deptId: record.deptId,
              level: record.level,
              status: record.status,
              loginCount: record.loginCount,
              isRecord: record.isRecord
            }
          )
        }, 100)
        // 时间单独处理
        if (record.birthdate != null) {
            this.form.getFieldDecorator('birthdate', { initialValue: moment(record.birthdate, 'YYYY-MM-DD') })
        }
        this.birthdateDateString = moment(record.birthdate).format('YYYY-MM-DD')
        // 时间单独处理
        if (record.employmentTime != null) {
            this.form.getFieldDecorator('employmentTime', { initialValue: moment(record.employmentTime, 'YYYY-MM-DD') })
        }
        this.employmentTimeDateString = moment(record.employmentTime).format('YYYY-MM-DD')
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.birthdate = this.birthdateDateString
            values.employmentTime = this.employmentTimeDateString
            baNurseUserEdit(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangebirthdate(date, dateString) {
        this.birthdateDateString = dateString
      },
      onChangeemploymentTime(date, dateString) {
        this.employmentTimeDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
